import { Inject, Injectable, Optional } from '@angular/core';
import {
  SearchAction,
  SearchActionHandler,
} from './models/search-action.model';
import { SEARCH_ACTION_HANDLER } from './tokens/search-action-handler.token';

/**
 * Routes a SearchAction to its registered handler by `type`.
 * Domain modules register their handler via SEARCH_ACTION_HANDLER multi-token.
 * The dispatcher is intentionally dumb — it just looks up the type and calls.
 */
@Injectable({ providedIn: 'root' })
export class SearchActionDispatcherService {
  private handlers = new Map<string, SearchActionHandler>();

  constructor(
    @Optional() @Inject(SEARCH_ACTION_HANDLER) handlers: SearchActionHandler[] | null
  ) {
    (handlers ?? []).forEach((h) => this.handlers.set(h.type, h));
  }

  /** Late-register a handler. */
  registerHandler(handler: SearchActionHandler): void {
    this.handlers.set(handler.type, handler);
  }

  async dispatch(action: SearchAction): Promise<void> {
    const handler = this.handlers.get(action.type);
    if (!handler) {
      console.warn(`[SearchActionDispatcher] No handler for action type "${action.type}"`);
      return;
    }
    await Promise.resolve(handler.handle(action));
  }
}
